import React from "react";
import {
    Avatar,
    Box,
    Button,
    Chip,
    Container,
    Grid,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InsightsIcon from "@mui/icons-material/Insights";
import { Link as RouterLink } from "react-router-dom";

function InfoBullet({ children }) {
    return (
        <Stack direction="row" spacing={1} alignItems="flex-start">
            <CheckCircleIcon sx={{ fontSize: 18, color: "#2563eb", mt: "2px" }} />
            <Typography
                sx={{
                    color: "#334155",
                    lineHeight: 1.65,
                    fontSize: { xs: "0.95rem", md: "0.98rem" },
                }}
            >
                {children}
            </Typography>
        </Stack>
    );
}

function HomeHero() {
    const heroBullets = [
        "Выявление фактов хищений и неправомерных выплат",
        "Исключение ручного труда и минимизация ошибок при проверке",
        "Широкий спектр выявления расхождений",
        "Выгрузка результатов сверки в Excel-файл",
    ];

    const heroSummaryStats = [
        { title: "Сумма по банку", value: "218 462 000 ₸" },
        { title: "Сумма по учету", value: "203 744 000 ₸" },
        { title: "Сумма отклонений", value: "14 718 000 ₸" },
        { title: "Всего ИИН", value: "582" },
    ];

    const heroDetailRows = [
        ["Ахметов******", "НЕТ В УЧЕТЕ", "Критично"],
        ["Омарова******", "НЕТ В БАНКЕ", "Критично"],
        ["Искаков******", "РАЗНИЦА", "Критично"],
        ["Калиева******", "РАЗНЫЕ ФИО", "Предупреждение"],
        ["Ибраева******", "РАЗНЫЕ СЧЕТА", "Предупреждение"],
        ["Жумабае******", "ОК", "Соответствует"],
    ];

    return (
        <Box
            sx={{
                position: "relative",
                overflow: "hidden",
                background:
                    "linear-gradient(180deg, #eff6ff 0%, #f8fafc 42%, #ffffff 100%)",
                pt: { xs: 6, md: 8 },
                pb: { xs: 7, md: 9 },
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: -120,
                    right: -120,
                    width: 380,
                    height: 380,
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(37,99,235,0.20) 0%, rgba(37,99,235,0.02) 70%, rgba(37,99,235,0) 100%)",
                }}
            />

            <Container maxWidth="xl">
                <Grid container spacing={{ xs: 4, md: 4.5 }} alignItems="center">
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Stack spacing={2.5}>

                            <Chip
                                label="Qarzhy – система автоматизированной сверки"
                                color="primary"
                                sx={{
                                    alignSelf: "flex-start",
                                    fontWeight: 700,
                                    borderRadius: 999,
                                    px: 0.5,
                                    height: "auto",
                                    maxWidth: { xs: "100%", sm: "fit-content" },
                                    py: 0.6,
                                    "& .MuiChip-label": {
                                        display: "block",
                                        whiteSpace: "normal",
                                        lineHeight: 1.35,
                                        textAlign: "left",
                                        px: 1.5,
                                        py: 0.6,
                                        fontSize: { xs: "0.72rem", sm: "0.8rem" },
                                    },
                                }}
                            />                            

                            <Typography
                                variant="h1"
                                sx={{
                                    fontSize: { xs: "1.65rem", sm: "2rem", md: "2.55rem" },
                                    fontWeight: 900,
                                    lineHeight: 1.08,
                                    color: "#0f172a",
                                    letterSpacing: "-0.035em",
                                    maxWidth: 680,
                                }}
                            >
                                Сверка банковских платежей с данными
                                бухгалтерского и кадрового учета
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: { xs: "0.98rem", md: "1.03rem" },
                                    color: "#475569",
                                    lineHeight: 1.75,
                                    maxWidth: 660,
                                }}
                            >
                                Qarzhy помогает находить расхождения, ошибки, подозрительные
                                выплаты, изменения банковских реквизитов, несоответствия по
                                сотрудникам и риски финансовых нарушений за минуты, а не за дни
                                ручной проверки.
                            </Typography>

                            <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
                                <Button
                                    variant="contained"
                                    size="large"
                                    component={RouterLink}
                                    to="/check-pp"
                                    sx={{
                                        px: 3,
                                        py: 1.25,
                                        borderRadius: 3,
                                        textTransform: "none",
                                        fontWeight: 700,
                                        fontSize: "0.95rem",
                                        boxShadow: "0 12px 24px rgba(37, 99, 235, 0.24)",
                                    }}
                                >
                                    Перейти к сверке
                                </Button>

                                <Button
                                    variant="outlined"
                                    size="large"
                                    href="#how-it-works"
                                    sx={{
                                        px: 3,
                                        py: 1.25,
                                        borderRadius: 3,
                                        textTransform: "none",
                                        fontWeight: 700,
                                        fontSize: "0.95rem",
                                        borderColor: "rgba(37,99,235,0.28)",
                                    }}
                                >
                                    Как это работает
                                </Button>
                            </Stack>

                            <Grid container spacing={1.25}>
                                {heroBullets.map((item) => (
                                    <Grid size={{ xs: 12, sm: 6 }} key={item}>
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                p: 1.35,
                                                borderRadius: 3,
                                                border: "1px solid rgba(148, 163, 184, 0.20)",
                                                bgcolor: "rgba(255,255,255,0.72)",
                                                backdropFilter: "blur(6px)",
                                            }}
                                        >
                                            <InfoBullet>{item}</InfoBullet>
                                        </Paper>
                                    </Grid>
                                ))}
                            </Grid>
                        </Stack>
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: { xs: 1.8, md: 2.3 },
                                borderRadius: 5,
                                background:
                                    "linear-gradient(180deg, #0f172a 0%, #172554 100%)",
                                color: "white",
                                boxShadow: "0 22px 52px rgba(15, 23, 42, 0.28)",
                                maxWidth: { xs: "100%", md: 540 },
                                ml: { xs: 0, md: "auto" },
                            }}
                        >
                            <Stack spacing={1.8}>
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Box>
                                        <Typography
                                            sx={{
                                                color: "rgba(255,255,255,0.70)",
                                                fontSize: 12,
                                                lineHeight: 1.45,
                                                mb: 0.4,
                                            }}
                                        >
                                            Результат сверки банковских платежных поручений с
                                            бухгалтерским учетом
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: { xs: "1rem", md: "1.1rem" },
                                                fontWeight: 800,
                                                lineHeight: 1.2,
                                            }}
                                        >
                                            Общая информация
                                        </Typography>
                                    </Box>

                                    <Avatar
                                        sx={{
                                            width: 40,
                                            height: 40,
                                            bgcolor: "rgba(255,255,255,0.12)",
                                        }}
                                    >
                                        <InsightsIcon sx={{ fontSize: 20 }} />
                                    </Avatar>
                                </Stack>

                                <Grid container spacing={1.4}>
                                    {heroSummaryStats.map((item) => (
                                        <Grid size={{ xs: 6 }} key={item.title}>
                                            <Paper
                                                elevation={0}
                                                sx={{
                                                    p: 1.35,
                                                    borderRadius: 3,
                                                    bgcolor: "rgba(255,255,255,0.08)",
                                                    border: "1px solid rgba(255,255,255,0.10)",
                                                    color: "white",
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: 12,
                                                        color: "rgba(255,255,255,0.68)",
                                                        mb: 0.35,
                                                        lineHeight: 1.35,
                                                    }}
                                                >
                                                    {item.title}
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontSize: { xs: 18, md: 18 },
                                                        fontWeight: 800,
                                                        lineHeight: 1.2,
                                                    }}
                                                >
                                                    {item.value}
                                                </Typography>
                                            </Paper>
                                        </Grid>
                                    ))}
                                </Grid>

                                <Paper
                                    elevation={0}
                                    sx={{
                                        p: 1.5,
                                        borderRadius: 3,
                                        bgcolor: "rgba(255,255,255,0.06)",
                                        border: "1px solid rgba(255,255,255,0.10)",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            mb: 1.2,
                                            color: "white",
                                            fontSize: "0.95rem",
                                        }}
                                    >
                                        Детальная информация
                                    </Typography>

                                    <Stack spacing={0.8}>
                                        {heroDetailRows.map((row) => (
                                            <Box
                                                key={row[0]}
                                                sx={{
                                                    display: "grid",
                                                    gridTemplateColumns: {
                                                        xs: "1fr",
                                                        sm: "1.1fr 1fr 0.9fr",
                                                    },
                                                    gap: { xs: 0.35, sm: 1 },
                                                    p: 1,
                                                    borderRadius: 2.5,
                                                    bgcolor: "rgba(255,255,255,0.05)",
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: 13,
                                                        color: "rgba(255,255,255,0.82)",
                                                        lineHeight: 1.35,
                                                    }}
                                                >
                                                    {row[0]}
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        fontSize: 13,
                                                        fontWeight: 700,
                                                        lineHeight: 1.35,
                                                        color:
                                                            row[2] === "Критично"
                                                                ? "#f87171"
                                                                : row[2] === "Предупреждение"
                                                                  ? "#fbbf24"
                                                                  : "#4ade80",
                                                    }}
                                                >
                                                    {row[1]}
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        fontSize: 12.5,
                                                        color: "rgba(255,255,255,0.70)",
                                                        lineHeight: 1.35,
                                                    }}
                                                >
                                                    {row[2]}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Stack>
                                </Paper>
                            </Stack>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}

export default HomeHero;